import { FormikProps } from "formik";

export const initialValues: PayNowFormData = {
  paymentAmounts: new Array<PaymentAmount>(),
  total: 0,
};

export const overpaymentMessage = "The payment amount you entered is greater than your current outstanding balance";

export const isOverpayment = (amount: PaymentAmount) => +amount.paymentAmount > amount.maximumPayment;

export type PaymentAmount = {
  paymentAmount: string;
  maximumPayment: number;
  clientID: string;
  rentPaymentAmount: string;
  maximumRentPayment: number;
  groundRentValue: number;
  isServiceChargeDevelopment: boolean;
};

export type PayNowFormData = {
  paymentAmounts: Array<PaymentAmount>;
  total: number;
};

export enum PayNowFormSteps {
  PaymentBreakdown,
  PaymentProvider,
  PaymentConfirmation,
  PaymentFailed,
}

export enum PayNowFormStepTitles {
  PaymentBreakdown = "Payment Breakdown",
  PaymentProvider = "Make Payment", // TODO: What should this say?
  PaymentConfirmation = "Payment Confirmation",
  PaymentFailed = "Payment Failed",
}

export type PayNowStepProps = {
  currentStep: PayNowFormSteps;
  formikProps: FormikProps<PayNowFormData>;
};
